import Vue from 'vue'
import Router from 'vue-router'


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}


Vue.use(Router)
const routes = [
	// 
	{
		path: '/', //首页
		component: () => import(/* webpackChunkName: "index" */  './view/Index.vue'),
		meta: {
			keepAlive: true // 需要缓存 
		},
	},
	{
		path: '/mobile', //首页
		component: () => import(/* webpackChunkName: "index" */  './view/Mobile/Index.vue'),
		meta: {
			keepAlive: true // 需要缓存 
		},
	},

	{
		path: '/login', //登录
		component: () => import(/* webpackChunkName: "login" */  './view/Login.vue'),
		meta: {
			keepAlive: true
		}
	}, {
		path: '/forget', //注册
		component: () => import(/* webpackChunkName: "forget" */  './view/Forget.vue'),
		meta: {
			keepAlive: true
		}
	}, {
		path: '/register', //忘记密码
		component: () => import(/* webpackChunkName: "register" */  './view/Register.vue'),
		meta: {
			keepAlive: true
		}
	}, 
	
	{
		path: '/news', //新闻
		component: () => import(/* webpackChunkName: "news" */  './view/News.vue'),
		meta: {
			keepAlive: true
		}
	}, {
		path: '/newslist', //新闻列表
		component: () => import(/* webpackChunkName: "newslist" */  './view/NewsList.vue'),
		meta: {
			keepAlive: true
		}
	}, {
		path: '/articles', //文章
		component: () => import(/* webpackChunkName: "articles" */  './view/Articles.vue'),
		meta: {
			keepAlive: false
		}
	}, 
	// {
	// 	path: '/datahub', //数据共享
	// 	component: () => import(/* webpackChunkName: "news" */  './view/DataHub.vue'),
	// 	meta: {
	// 		keepAlive: false
	// 	}
	// },
	{
		path: '/datahub', //数据服务
		component: () => import(/* webpackChunkName: "news" */  './view/DataServer.vue'),
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/dataSearch', //数据搜索
		component: () => import(/* webpackChunkName: "news" */  './view/DataSearch.vue'),
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/datadetails', //数据详情
		component: () => import(/* webpackChunkName: "news" */  './view/DataDetails.vue'),
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/datainfo', //数据共享
		component: () => import(/* webpackChunkName: "datainfo" */  './view/DataInfo.vue'),
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/private', //个人空间
		component: () => import(/* webpackChunkName: "private" */  './view/Private.vue'),
		meta: {
			keepAlive: false,
			requireAuth: true,
			path:'/private'
		}
	},
	{
		path: '/appMaket', //应用市场
		component: () => import(/* webpackChunkName: "appMaket" */  './view/AppMarket.vue'),
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/sdgsindicators', //应用市场
		component: () => import(/* webpackChunkName: "appMaket" */  './view/SdgsIndicators.vue'),
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/sdgsreports', //报告
		component: () => import(/* webpackChunkName: "appMaket" */  './view/SdgsReports1.vue'),
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/test', //应用市场
		component: () => import(/* webpackChunkName: "appMaket" */  './view/Test.vue'),
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/about', //关于我们
		component: () => import(/* webpackChunkName: "appMaket" */  './view/AboutUs.vue'),
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/contact', //联系我们
		component: () => import(/* webpackChunkName: "appMaket" */  './view/Contactus.vue'),
		meta: {
			keepAlive: true
		}
	}

	


];
export default new Router({
	mode: 'history',
	// base:'/sdg-api',
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	}
})
